import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CompassLogo } from "@/components/CompassLogo";
import { api, getApiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n/LanguageContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const { lang } = useLang();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        toast.error(lang === "fr" ? "Connexion Google incomplète : identifiant de session manquant." : "Google sign-in incomplete: missing session id.");
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data);
        window.history.replaceState({}, "", "/app/reperes");
        navigate("/app/reperes", { replace: true });
      } catch (err) {
        toast.error(getApiErrorMessage(err, lang));
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser, lang]);

  return (
    <div className="min-h-screen grid place-items-center bg-paper">
      <div className="flex flex-col items-center gap-3">
        <CompassLogo size={48} className="animate-spin" />
        <span className="text-sm text-ink/60">…</span>
      </div>
    </div>
  );
}
